const { PUBLIC_URL = '/home/public/' } = process.env

export default {
  bannerA: 'Save up to 50% by searching Express Deals.',
  bannerB: 'Trusted airlines, incredible deals.',
  image: `${PUBLIC_URL}assets/images/airlines/flights_logo_bumper.jpg`,
  imageWebP: `${PUBLIC_URL}assets/images/airlines/flights_logo_bumper.webp`,
  height: '25px',
  imageBackgroundColor: '#f8f8f8'
}
